
import React, { useContext } from 'react';
import { Box, Button, Paper, Typography } from "@material-ui/core";
import { Store } from "../store";
import { useStyles } from "../styles.jsx";
import { getRestauranteFromStorage } from '../services/selectedRestaurante';

const OrderDetailsFooter = ({ btnLeft, btnLeftHandler, btnRight, btnRightHandler }) => {
    const styles = useStyles();
    const { state } = useContext(Store);
    const { tax, total, itemsCount, orderItems } = state.order;
    const { pointsNeeded } = state.loyaltyCalculation;
    
    // Verificar se o programa de fidelidade está ativo no restaurante
    const restaurante = getRestauranteFromStorage();
    const programaFidelidadeAtivo = restaurante?.programaFidelidadeAtivo === true;
    
    console.log("OrderDetailsFooter - loyaltyCalculation:", state.loyaltyCalculation);
    console.log("OrderDetailsFooter - pointsNeeded:", pointsNeeded);
    console.log("OrderDetailsFooter - restaurante:", restaurante);
    console.log("OrderDetailsFooter - programaFidelidadeAtivo:", programaFidelidadeAtivo);

    const handleTotal = (total) => {
        if (!total)
            total = 0;

        const formatoBRL = new Intl.NumberFormat('pt-BR', {
            style: 'currency',
            currency: 'BRL'
        });
        return formatoBRL.format(total);
    }

    const handleTaxa = (taxa) => {
        if (!taxa)
            taxa = 0;

        const formatoBRL = new Intl.NumberFormat('pt-BR', {
            style: 'currency',
            currency: 'BRL'
        });
        return formatoBRL.format(taxa);
    }
    
    const handleItensCount = (itemsCount) => {
        if (!itemsCount)
            itemsCount = 0;

        return itemsCount;
    }

    return (
        <Paper 
            elevation={8}
            style={{
                padding: '24px',
                borderRadius: '12px 12px 0 0',
                position: 'sticky',
                bottom: 0,
                zIndex: 100,
                backgroundColor: '#f8f8f8',
                opacity: 1, // Força opacidade total
                pointerEvents: 'auto', // Garante que eventos do mouse funcionem
            }}
        >
            <Box 
                className={styles.orderSummaryBox}
                style={{ 
                    backgroundColor: '#f0f0f0', 
                    marginBottom: '24px',
                    borderRadius: '16px',
                    padding: '16px 24px',
                    opacity: 1, // Força opacidade total
                }}
            >
                <Box display="flex" justifyContent="space-between" alignItems="center" mb={1}>
                    <Typography variant="h4" style={{ fontSize: '2rem', fontWeight: 500, opacity: 1 }}>
                        Taxa de serviço:
                    </Typography>
                    <Typography variant="h4" style={{ fontSize: '2rem', fontWeight: 700, opacity: 1 }}>
                        {handleTaxa(tax)}
                    </Typography>
                </Box>
                <Box display="flex" justifyContent="space-between" alignItems="center" mb={1}>
                    <Typography variant="h4" style={{ fontSize: '2rem', fontWeight: 500, opacity: 1 }}>
                        Itens:
                    </Typography>
                    <Typography variant="h4" style={{ fontSize: '2rem', fontWeight: 700, opacity: 1 }}>
                        {handleItensCount(itemsCount)}
                    </Typography>
                </Box>
                <Box display="flex" justifyContent="space-between" alignItems="center">
                    <Typography variant="h2" style={{ fontSize: '2.4rem', fontWeight: 700, opacity: 1 }}>
                        Total:
                    </Typography>
                    <Typography variant="h2" style={{ fontSize: '2.4rem', fontWeight: 700, color: '#388e3c', opacity: 1 }}>
                        {handleTotal(total)}
                    </Typography>
                </Box>
                {pointsNeeded > 0 && programaFidelidadeAtivo && (
                    <Box display="flex" justifyContent="space-between" alignItems="center" mt={1}>
                        <Typography variant="h5" style={{ fontSize: '1.8rem', fontWeight: 600, color: '#ff9800', opacity: 1 }}>
                            Para pagar com pontos:
                        </Typography>
                        <Typography variant="h5" style={{ fontSize: '1.8rem', fontWeight: 700, color: '#ff9800', opacity: 1 }}>
                            {pointsNeeded} pontos
                        </Typography>
                    </Box>
                )}
            </Box>
            <Box display="flex" gap="24px">
                <Button
                    variant="outlined"
                    style={{
                        flex: 1,
                        height: '100px',
                        fontSize: '2.4rem',
                        borderRadius: '20px',
                        boxShadow: '0 8px 16px rgba(0,0,0,0.25)',
                        textTransform: 'uppercase',
                        fontWeight: 'bold',
                        color: '#ffffff',
                        backgroundColor: '#d32f2f',
                        borderColor: '#b71c1c',
                        borderWidth: '3px',
                        marginRight: '24px',
                        opacity: 1, // Força opacidade total
                        '&:active': {
                            opacity: 1, // Mantém opacidade total mesmo quando ativo
                            backgroundColor: '#d32f2f',
                        }
                    }}
                    onClick={btnLeftHandler}
                    className={styles.touchFeedback}
                >
                    {btnLeft}
                </Button>
                <Button
                    variant="contained"
                    style={{
                        flex: 1,
                        height: '100px',
                        fontSize: '2.4rem',
                        borderRadius: '20px',
                        backgroundColor: orderItems.length === 0 ? '#a5d6a7' : '#388e3c',
                        color: '#fff',
                        boxShadow: '0 8px 16px rgba(0,0,0,0.25)',
                        textTransform: 'uppercase',
                        fontWeight: 'bold',
                        borderWidth: '3px',
                        borderColor: '#2e7d32',
                        opacity: 1, // Força opacidade total
                        '&:active': {
                            opacity: 1, // Mantém opacidade total mesmo quando ativo
                            backgroundColor: orderItems.length === 0 ? '#a5d6a7' : '#388e3c',
                        }
                    }}
                    onClick={btnRightHandler}
                    disabled={orderItems.length === 0}
                    className={styles.touchFeedback}
                >
                    {btnRight}
                </Button>
            </Box>
        </Paper>
    );
}

export default OrderDetailsFooter;
